import { requiredMessage } from "../utils/common";
var validateMedicareFirstDigit = function validateMedicareFirstDigit(digit) {
  return digit >= 2 && digit <= 6;
};
var validateMedicareLength = function validateMedicareLength(value) {
  return value.length === 10 || value.length === 11;
};
var validateMedicareChecksum = function validateMedicareChecksum(value) {
  var matches = value.match(/^(\d{8})(\d)/);
  var base = matches !== null ? matches[1] : "";
  var checkDigit = matches !== null ? matches[2] : "";
  var weights = [1, 3, 7, 9, 1, 3, 7, 9];
  var checkSum = 0;
  for (var i = 0; i < weights.length; i++) {
    checkSum += Number(base[i]) * weights[i];
  }
  return checkSum % 10 === Number(checkDigit);
};
var VARIANTS = {
  ARHI: "Medicare number"
};
var validMedicareNumber = function validMedicareNumber(value) {
  var funnel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "ARHI";
  var fieldName = arguments.length > 2 ? arguments[2] : undefined;
  var error; // eslint-disable-line init-declarations
  var field = fieldName || VARIANTS[funnel] || VARIANTS.ARHI;
  if (!value) {
    error = requiredMessage(field);
  } else if (isNaN(Number(value))) {
    error = "Your ".concat(field, " should only be digits.");
  } else if (!validateMedicareLength(value)) {
    error = "Your ".concat(field, " should be 10 or 11 digits.");
  } else if (!validateMedicareFirstDigit(Number(value[0]))) {
    error = "Your ".concat(field, " first digit should be between 2 and 6.");
  } else if (!validateMedicareChecksum(value)) {
    error = "Your ".concat(field, " is not valid.");
  }
  return error;
};
export default validMedicareNumber;